import { useState } from "react";
import { Link } from "react-router-dom";
import { FormField, Input } from "@cp/ui";
import { requestPasswordReset } from "../api/authApi";
import { AuthLayout } from "../components/AuthLayout";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async () => {
    setBusy(true);
    setError(null);
    try {
      await requestPasswordReset(email.trim().toLowerCase());
      setDone(true);
    } catch (e) {
      setError(String(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout
      title={done ? "E-Mail ist unterwegs" : "Passwort zurücksetzen"}
      description={
        done
          ? "Wenn ein Konto mit dieser E-Mail existiert, erhalten Sie in Kürze einen Reset-Link."
          : "Wir senden Ihnen einen sicheren Link, der 60 Minuten gültig ist."
      }
    >
      {done ? (
        <Link to="/login" className="btn-primary auth-form__submit">
          Zurück zur Anmeldung
        </Link>
      ) : (
        <form className="auth-form" onSubmit={(event) => { event.preventDefault(); void submit(); }}>
            <p className="account-lead">
              Hinweis: Ihr lokales Tresor-Kennwort wird dadurch nicht geändert.
            </p>
            <FormField label="E-Mail" htmlFor="forgot-email" required>
              <Input
                id="forgot-email"
                type="email"
                autoComplete="username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </FormField>
            <button
              type="submit"
              className="btn-primary auth-form__submit"
              disabled={busy || !email.trim()}
            >
              {busy ? "Link wird gesendet …" : "Reset-Link senden"}
            </button>
            {error ? <p className="account-message account-message--error" role="alert">{error}</p> : null}
            <Link to="/login" className="auth-form__text-link">Zur Anmeldung</Link>
        </form>
      )}
    </AuthLayout>
  );
}
